import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types';
import {
    Button, Grid, withStyles, TextField, Paper, Typography, FormControl, FormLabel, RadioGroup, FormControlLabel,
    Divider, Link, Box, CircularProgress, Radio,
} from '@material-ui/core';
import { Field } from 'redux-form';
import { compose } from 'redux';
import { reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { styles } from '../../styles';
import * as actions from '../../../store/actions/members';
import AlertDialog from '../../common/AlertDialog';

class VerifyCode extends Component {

    constructor(props){
        super(props);
        this.state = {
            showRegistrationForm: true,
            appRegistration: false,
            nextStep: false,
            enterCode: false,
            activationCode: 0,
            selectedOption: 'email',
            showAlert: false,
            activationCodeError: ''
        }
    }
    componentDidMount = () => {
        if (this.props.userInfo === undefined) {
            this.props.history.push('/login');
        }
    }
    handleChange = (event) => {
        const value = parseInt(event.target.value);
        const name = event.target.name;
        this.setState({[name]: value}, ()=> {
            switch(name) {
                case 'activationCode':
                    if (value !== this.props.verificationCode) {
                        this.setState({ activationCodeError: "Please enter valid activation code"});
                    } else {
                        this.setState({ activationCodeError: ""});
                    }
                break;
                default:
                    //
            }
        });
    };


 
    renderTextField = (props) => {
        const {input, meta : {touched, warning}, label, error, isIcon, multiline, handleShow, ...custom} = props;
        return (
            <div>
            <TextField
                name={input.name}
                id={input.name}
                label={label}
                error={touched && (error==='Required')}
                helperText={touched && ((error && <span className="text-danger">{error}</span>) || (warning && <span>{warning}</span>))}
                margin="normal"
                size="small"
                variant="outlined" 
                fullWidth={true}
                type="number"              
                {...input}
                {...custom}
                style={{backgroundColor: 'white'}}
            />
            {this.state.activationCodeError && <Typography variant="caption" color="error">{this.state.activationCodeError}</Typography>}
            {this.props.errorMessage && <Typography variant="caption" color="error">{this.props.errorMessage}</Typography>}
            </div>
        );
    }    

    renderField = (name, label, value, required, error, password, isIcon, handleShow) => {
        return(
            <Field
                name={name} component={this.renderTextField} label={label} required={required} isIcon={isIcon}
                type={password} onChange={this.handleChange} handleShow={handleShow} error={error}
            />
        )
    }

    renderButton = (label, handler, color, disabled, variant) => {
         return (
            <Button variant={variant || "contained"} color={color || "primary"} onClick={handler} size="small" disabled={disabled}>
                {label}
            </Button>
        );
    }


    renderProgress = () => {
        const { loading } = this.props;
        if (loading) {
            return (
                <CircularProgress
                    size={70}
                    color={"secondary"}
                    style={{position: 'absolute', jusitfyContent: 'center', top: 0, left: 0, bottom: 0, right: 0, margin: 'auto'}}
                />
            );
        } else {
            return null;
        }
    }

    handleNext = () => {
        const { userInfo } = this.props;
        if (userInfo) {
            let params= {};
            params.userId= userInfo.userId;
            params.email = userInfo.email;
            params.memberId = userInfo.memberId;
            params.activationCode = this.state.activationCode;
            this.props.dispatch(actions.memberActivation(params, () => {
                this.setState({ showAlert: true, activationCode: 0});
                }));
        }
    }
    closeAlert = () => {
        if(this.state.showAlert){
            this.setState({ showAlert: false });
        }
        this.props.history.push('/login');
    }
    renderCode = () => {
        return(
            <Grid container>
                <Grid item key={101} xs={11} sm={8} md={7} lg={6} style={{ paddingTop: "20px" }}>
                    {this.renderField('activationCode', 'Activation code', this.state.activationCode, true, false)}
                </Grid>
                <Grid item key={102} xs={1} sm={4} md={5} lg={6} style={{ paddingTop: "20px" }}></Grid>
                <Grid item key={103} xs={12} sm={12} md={12} lg={12} style={{ paddingTop: "10px" }}>
                    {this.renderButton('Next',() => this.handleNext(), "secondary", (this.state.activationCode !== this.props.verificationCode || this.state.activationCodeError))}
                    <Button color="secondary" size="small" style={{ marginLeft: "20px"}} onClick={() => this.setState({ enterCode: false })}>Cancel</Button>
                </Grid>
            </Grid>
        )
    }
    handleSelectChange = (event) => {
        this.setState({ selectedOption: event.target.value });
    };
    getVerificationCode = () => {
        const { userInfo } = this.props;
        if(userInfo) {
            let params= {};
            params.userId= userInfo.userId;
            params.email = userInfo.email;
            params.memberId = userInfo.memberId;
            params.phone = userInfo.phone;
            this.props.dispatch(actions.getMemberVerificationCode(params, () => {
                // this.props.history.push('/');
                }));
        }
    }
    resendVerificationCode = () => {
        const { userInfo } = this.props;
        if(userInfo) {
            let params= {};
            params.userId= userInfo.userId;
            params.email = userInfo.email;
            params.memberId = userInfo.memberId;
            params.activationCode = this.props.verificationCode;
            params.phone = userInfo.phone;
            this.props.dispatch(actions.getMemberVerificationCode(params, () => {
                // this.props.history.push('/');
                }));
        }
    }
    generateVerificationCode = () => {
        return(
            <Grid container>
                <Grid item key={2} xs={12} sm={12} md={12} lg={12} style={{ paddingTop: "20px" }}>
                    <FormControl component="fieldset">
                        <FormLabel component="legend">Please choose, where you would like to receive verification code:</FormLabel>
                        <RadioGroup name="verificationCode" value={this.state.selectedOption} onChange={this.handleSelectChange}>
                            <FormControlLabel value="email" control={<Radio />} label="Email" />
                            <FormControlLabel value="mobile" control={<Radio />} label="Mobile" />
                        </RadioGroup>
                    </FormControl>
                    </Grid>
                    <Grid item key={3} xs={12} sm={12} md={12} lg={12} >
                        <Grid container justify='center' alignItems='center'>
                            {this.renderButton('Get Verification Code',() => this.getVerificationCode(), "secondary", !this.props.userInfo)}
                        </Grid>
                    </Grid>
            </Grid>
        )
    }
    renderNextStep = () => {
        return(
            <Paper elevation={1} style={{ width: "600px", padding: "20px" }}>
                <Grid container spacing={1}>
                    <Grid item key={1} xs={12} sm={12} md={12} lg={12}>
                        <Typography variant="h6" color="primary">
                            <Box fontWeight="fontWeightBold">
                                Next Step: Verify your member account
                            </Box>
                        </Typography>
                    </Grid>

                    {(!this.state.showAlert && !this.props.verificationCode) && this.generateVerificationCode()}
                    {(this.state.showAlert || this.props.verificationCode) && this.renderCode()}
                    <Grid item key={5} xs={12} sm={12} md={12} lg={12} style={{ paddingTop: "20px" }}>
                        <Divider style={{height: "2px" }} />
                    </Grid>
                    <Grid item key={6} xs={12} sm={12} md={12} lg={12} style={{ paddingTop: "20px" }}>
                        <Typography variant="caption"  component={'span'} >Still waiting for your verification code? 
                                <Box fontWeight="fontWeightRegular" display="inline">
                                    <Link href="#" onClick={this.resendVerificationCode}> Resend email</Link>/
                                    { this.props.userInfo && this.props.userInfo.phone && <Link href="#" onClick={this.resendVerificationCode}>Resend sms</Link>}
                                </Box> 
                        </Typography>
                    </Grid>
                    <Grid item key={7} xs={12} sm={12} md={12} lg={12} style={{ paddingTop: "20px" }}>
                        <Typography variant="caption">If you don't see it, check your junk or spam folders. You may need to resend the message or add our address to your approved senders.</Typography>
                    </Grid>
                    <Grid item key={8} xs={12} sm={12} md={12} lg={12} style={{ paddingTop: "20px" }}>
                        <Typography variant="caption"  component={'span'} >
                            If you'd like assistance, contact support at 1-000-000-0000 or <Box fontWeight="fontWeightRegular" display="inline"><Link href="mailto:support@myelth.com" >support@myelth.com</Link></Box>
                        </Typography>
                    </Grid>
                    
                </Grid>
            </Paper>
        )
    }
    render() {
        return (
            <Fragment>
                <Grid container justify="center" alignItems="center" style={{ padding: "20px" }}>
                    {this.renderNextStep()}
                </Grid>
                {this.state.showAlert && <AlertDialog open={true} message="Member registration is complete" close={this.closeAlert}/>}
                {this.renderProgress()}
            </Fragment>
        )
    }
}

VerifyCode.propTypes = {
    classes: PropTypes.object.isRequired,
    theme: PropTypes.object.isRequired,
};


const mapDispatchToProps = (dispatch) => {
    return { dispatch };
};

const mapStateToprops = (state) => {
    return {
        loading: state.members && state.members.loading,
        userInfo: state.members && state.members.userParams,
        verificationCode: state.members && state.members.verificationCode,
        errorMessage: state.members && state.members.errorMessage,
        initialValues: {
            
        }
    };
};

VerifyCode = reduxForm({ 
    form: 'EmailAuth' ,
    enableReinitialize: true,
    fields: [
    ]
})(VerifyCode);

export default compose(
    withStyles(styles, { withTheme: true }),
    connect(mapStateToprops, mapDispatchToProps)
)(VerifyCode); 